import { useTranslation } from 'react-i18next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'

const LANGUAGES = [
  { code: 'vi', labelKey: 'Vietnamese' },
  { code: 'en', labelKey: 'English' },
  { code: 'ja', labelKey: 'Japanese' }
] as const

export const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation()

  const current = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[1]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' size='sm' className='gap-1.5 h-9 px-2 font-medium'>
          <span className='text-sm'>
            <span className='hidden sm:inline ml-1'>{t(current.labelKey as any)}</span>
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='min-w-[140px]'>
        {LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={
              i18n.language === lang.code
                ? 'bg-secondary text-primary font-semibold'
                : 'cursor-pointer'
            }
          >
            {t(lang.labelKey as any)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
